import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/welcome-image.png'


const _hoisted_1 = { class: "default-layout" }
const _hoisted_2 = { class: "container-fluid login-page" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-lg-auto position-md-static position-relative\"><div class=\"benefit-img\"><div class=\"background-gradient\"></div><div class=\"welcome-img\"><img src=\"" + _imports_0 + "\" alt=\"Welcome to P&amp;A Group’s Insurance Election Portal\"><div class=\"benefits-section p-3 p-md-0\"><h1 class=\"benefit-title mb-3\"> Welcome to P&amp;A Group’s Insurance Election Portal </h1><p> Here you can view your insurance options and enroll in available coverage for you and your family. Log in now to make your election(s). </p></div><div class=\"black-gradient\"></div></div></div></div>", 1)
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "login-section p-3 p-md-0" }
const _hoisted_7 = { class: "login-form mt-3 mt-lg-auto" }
const _hoisted_8 = { class: "footer-row" }
const _hoisted_9 = { class: "footer-links" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DefaultHeaderComponent = _resolveComponent("DefaultHeaderComponent")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DefaultHeaderComponent),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "default"),
              _createVNode(_component_router_view)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: _ctx.links.contactUs,
                      target: "_blank"
                    }, "Contact Us", 8, _hoisted_10)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: _ctx.links.privacyPolicy,
                      target: "_blank"
                    }, "Privacy Statement", 8, _hoisted_11)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}